import { isDefined } from "@omni/utils/helper.utils";
import { ComponentProps, createContext, ReactNode, use } from "react";

import { RenderImage } from "@/components/General/Image/types/renderImage.type";

type ImageContextValue = {
    alt: string;
    lazy: boolean;
    image: RenderImage;
    mobileImage?: RenderImage;
} & Omit<
    ComponentProps<"img">,
    "alt" | "src" | "srcSet" | "lazy" | "className"
>;

type ImageContextProviderProps = {
    alt: string;
    lazy: boolean;
    image: RenderImage;
    mobileImage?: RenderImage;
    children: ReactNode;
} & Omit<
    ComponentProps<"img">,
    "alt" | "src" | "srcSet" | "lazy" | "className"
>;

export const ImageContext = createContext<ImageContextValue | undefined>(
    undefined
);
ImageContext.displayName = "ImageContext";

export const ImageContextProvider = ({
    children,
    ...props
}: ImageContextProviderProps) => {
    return <ImageContext value={props}>{children}</ImageContext>;
};

export const useImageContext = () => {
    const context = use<ImageContextValue | undefined>(ImageContext);

    if (!isDefined(context)) {
        throw new Error(`${ImageContext.displayName} is undefined.`);
    }

    return context;
};
